import { getArticles, getCategories } from "/src/main.js";

export const prerender = true;

export async function load({ params }) {
	const articles = await getArticles().then(articles => articles.reverse())
	const categories = await getCategories()
	return {
		articles: articles,
		categories: categories,
	}
}